import { useEffect, useRef, useState } from "react";
import { validateEmail } from "../../../../../common/helper";
import Alert from "../../../../components/Alert/Alert";

interface HeroProps {
    title: string;
    subtitle?: string;
    subheading?: string;
}

export default function Hero({ title, subtitle, subheading }: HeroProps) {
    const [emailSent, setEmailSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [email, setEmail] = useState("");

    const errorTimeout = useRef(null);
    const validTimeout = useRef(null);

    const sendContact = async () => {
        const isValid = validateEmail(email);

        if (isValid) {
            setLoading(true);
            const response = await fetch(
                `/api/email/subscribe?email=${email}&type=meetups`
            ).then((res) => res.json());
            if (response.data === "success") {
                setLoading(false);
                setEmailSent(true);
                setEmail("");
                validTimeout.current = setTimeout(() => {
                    setEmailSent(false);
                }, 5000);
            }
        } else {
            setError("Unesite validan email");
            errorTimeout.current = setTimeout(() => {
                setError("");
            }, 5000);
        }
    };

    useEffect(() => {
        return () => {
            clearTimeout(validTimeout.current);
            clearTimeout(errorTimeout.current);
        };
    }, []);

    return (
        <section className="bg-gray-light">
            <div className="pt-10 pb-32 md:py-20 md:pb-40 text-center max-w-screen-sm m-auto px-6 lg:px-0">
                <p className="font-medium text-primary-600">{subheading}</p>

                <h1 className="text-3xl md:text-4xl leading-tight pt-4 pb-6 font-semibold text-primary-900">
                    {title}
                </h1>
                <p className="text-md md:text-lg text-gray-dark">{subtitle}</p>
                <div className="flex flex-col md:flex-row items-center text-left justify-between mt-12">
                    <div className="relative w-full m-auto max-w-md">
                        <input
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Email adresa"
                            className="relative w-full border border-gray text-gray-dark hover:border-blue transition-all duration-300 rounded-full h-16 pl-8 pr-4 box-border"
                        />
                        <button
                            type="button"
                            className="absolute btn-primary w-40 top-2 right-4"
                            onClick={() => sendContact()}
                        >
                            <span className="inline-block">Obavijesti me</span>
                        </button>
                    </div>
                </div>
            </div>
            {emailSent && <Alert message="Hvala na prijavi!" type="success" />}
            {error && <Alert type="error" message={error} />}
        </section>
    );
}
